import * as browser from "webextension-polyfill";
import { injectionOrigins, getInfoCommand } from "../shared";
import { datasetKey, nodeId } from "./info-injector.types";
function getDocumentReference() {
    return window.document;
}
async function getInfo() {
    return await browser.runtime.sendMessage({ command: getInfoCommand });
}
function createInfoElement(document, info) {
    const element = document.createElement("div");
    element.id = nodeId;
    element.style.display = "none";
    element.textContent = info;
    return element;
}
function isRelevantOrigin(origin) {
    return injectionOrigins.includes(origin);
}
async function injectInfo() {
    const document = getDocumentReference();
    if (!isRelevantOrigin(document.location.origin)) {
        return;
    }
    const info = JSON.stringify(await getInfo());
    const element = createInfoElement(document, info);
    document.addEventListener("DOMContentLoaded", () => {
        document.body.appendChild(element);
    });
    document.documentElement.dataset[datasetKey] = info;
}
function start() {
    void injectInfo();
}
start();
